import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getWebsiteConfig } from '../websiteConfig';

const WebsiteContext = createContext();

export const useWebsite = () => {
  return useContext(WebsiteContext);
};

export const WebsiteProvider = ({ children }) => {
  const [websiteId, setWebsiteId] = useState(null);
  const params = useParams();
  const location = useLocation();

  useEffect(() => {
    let currentId = null;
    
    // Try to get websiteId from params if available (for routes that have :websiteId)
    if (params.websiteId) {
      currentId = params.websiteId;
      setWebsiteId(currentId);
      localStorage.setItem('currentWebsiteId', currentId);
    } else {
      // Fallback: try to extract from path if not in params (e.g. if outside a route that captures it)
      const pathParts = location.pathname.split('/');
      if (pathParts.length > 1 && pathParts[1]) {
         // This is a heuristic, might need refinement
         // Assuming first segment is websiteId
         // setWebsiteId(pathParts[1]);
      }
      currentId = localStorage.getItem('currentWebsiteId') || 'default';
    }

    if (currentId) {
      const config = getWebsiteConfig(currentId);
      
      // Update document title
      document.title = config.fullName || config.name || "360Exams";
      
      // Update meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription && config.formattedDescription) {
        // Remove markdown formatting (**text**) for the meta description
        const cleanDesc = config.formattedDescription.replace(/\*\*/g, '');
        metaDescription.setAttribute("content", cleanDesc);
      }

      // Update favicon
      let favicon = document.querySelector('link[rel="icon"]');
      if (favicon && config.logo) {
        favicon.setAttribute('href', config.logo);
      }
      
      // Update apple-touch-icon
      let appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
      if (appleIcon && config.logo) {
        appleIcon.setAttribute('href', config.logo);
      }
    }
  }, [params, location]);

  return (
    <WebsiteContext.Provider value={{ websiteId, setWebsiteId }}>
      {children}
    </WebsiteContext.Provider>
  );
};
